export class UncontrolledEntityValidationErrorResponse {
  name: any;
  code: any;
  description: any;
  'domicile.countryId': any;
}
